/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ThreadsControllerFindOneQueryResponse, ThreadsControllerFindOnePathParams, ThreadsControllerFindOne401, ThreadsControllerFindOne403, ThreadsControllerFindOne404 } from "../../models/threadsController/ThreadsControllerFindOne";

function getThreadsControllerFindOneUrl(threadId: ThreadsControllerFindOnePathParams["threadId"]) {
  const res = { method: 'GET', url: `/api/v1/threads/${threadId}` as const }  
  return res
}

/**
 * @description Retrieve detailed information about a specific thread.
 * @summary Get a single thread
 * {@link /api/v1/threads/:threadId}
 */
export async function threadsControllerFindOne(threadId: ThreadsControllerFindOnePathParams["threadId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ThreadsControllerFindOneQueryResponse, ResponseErrorConfig<ThreadsControllerFindOne401 | ThreadsControllerFindOne403 | ThreadsControllerFindOne404>, unknown>({ method : "GET", url : getThreadsControllerFindOneUrl(threadId).url.toString(), ... requestConfig })  
  return res.data
}